<template>
  <XButton class="create-button" type="primary" :disabled="disabled" @click="handleClick">
    <iconpark-icon name="ai" class="mr-1"></iconpark-icon> {{ btnText }}
  </XButton>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { PageKey } from '~/constants/page';
import XButton from '~/design/atom/button.vue';

const { t: $t } = useI18n();

interface Props {
  btnText?: string;
  disabled?: boolean;
}

const props = defineProps<Props>();

const userInfo = useUserInfo();
const emit = defineEmits(['create-work']);
const route = useRoute();

const btnText = computed(() => {
  if (props.btnText) {
    return props.btnText;
  }

  if (!userInfo.value) {
    return $t('mian-fei-ti-yan');
  }

  if (route.name === PageKey.CHARACTER_DETAIL) {
    return $t('yong-ta-chuang-zuo');
  }

  return $t('chuang-zuo-tong-kuan');
});

const handleClick = () => {
  if (!userInfo.value) {
    navigateTo(`/login?redirect=${encodeURIComponent(encodeURIComponent(location.href))}`);
  } else {
    emit('create-work');
  }
};
</script>
<style lang="scss" scoped>
.create-button {
  padding: 10px 49.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
}
</style>
